<template>
  <v-container>
    <div class="mt-12">
      <v-alert text dense color="deep-orange" icon="mdi-text-search" border="left">
        In order to see products, you need to add conditions to filter, then
        press <strong>Filter products</strong> button. If you want to see all
        products, just press <strong>Filter products</strong> button without any
        conditions added.
      </v-alert>
    </div>
    <div class="mt-12">
      <FilterForm @formatValues="formatFilterValues" :showButtons="true" ref="filterComponent"></FilterForm>
    </div>

    <v-snackbar v-model="snackbarEmpty">
      {{ errorEmpty }}
    </v-snackbar>

    <v-divider class="my-2"></v-divider>

    <!-- <v-row justify="start" v-if="selectedProducts.length > 0">
      <v-col cols="2">
        <v-btn
          :loading="loadingExport"
          color="green"
          outlined
          @click="showPopup"
          ><v-icon left> mdi-export-variant </v-icon>
          Export
          <v-icon v-if="exportDone" right>mdi-check-circle</v-icon>
        </v-btn>
      </v-col>
      <v-col cols="2">
        <v-autocomplete
          v-model="platform"
          :items="platforms"
          outlined
          :item-text="'platform'"
          :item-value="'platform'"
          dense
          label="Select platform to upload"
          placeholder="Platform..."
          color="accent"
          prepend-inner-icon="mdi-magnify"
          :return-object="true"
          @change="uploadToPlatform"
        >
          <template slot="item" slot-scope="{ item }">
            <p class="fullName">
              {{ item.platform }}
              <span class="grey--text"> ({{ item.code }}) </span> &nbsp;&nbsp;

              <v-icon color="success">mdi-upload</v-icon>
            </p>
          </template>
</v-autocomplete>
</v-col>
</v-row> -->

    <v-row>
      <v-col>
        <v-data-table class="mt-6" v-model="selectedProducts" :headers="headers" :items="items" show-select
          item-key="SKU" :single-expand="true" :expanded.sync="expanded" show-expand :search="search" dense
          :options.sync="options" :server-items-length="totalItems" :loading="loading" height="65vh" fixed-header
          :footer-props="{
            'items-per-page-options': [50, 100, 150, 200, 500],
          }">
          <template v-slot:top>
            <v-row class="pb-1">
              <v-col cols="3" v-if="selectedProducts.length > 0">
                <v-autocomplete v-model="platform" :items="platforms" outlined :item-text="'platform'"
                  :item-value="'platform'" dense label="Select platform to upload" placeholder="Platform..."
                  color="accent" prepend-inner-icon="mdi-magnify" :return-object="true" @change="uploadToPlatform"
                  hide-details="auto">
                  <template slot="item" slot-scope="{ item }">
                    <p class="fullName">
                      {{ item.platform }}
                      <span class="grey--text"> ({{ item.code }}) </span>
                      &nbsp;&nbsp;

                      <v-icon color="success">mdi-upload</v-icon>
                    </p>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col cols="2" v-if="selectedProducts.length > 0">
                <v-btn :loading="loadingExport" color="green" outlined @click="showPopup"><v-icon left>
                    mdi-export-variant </v-icon>
                  Export
                  <v-icon v-if="exportDone" right>mdi-check-circle</v-icon>
                </v-btn>
              </v-col>

              <v-spacer></v-spacer>
              <v-col cols="6" class="pl-0">
                <v-text-field v-model="search" label="Search" class="mx-4" outlined dense
                  hide-details="auto"></v-text-field>
              </v-col>
            </v-row>
          </template>
          <template v-slot:[`item.Photos`]="{ item }">
            <tr v-for="(itm, p) in item.Photos" :key="p">
              <td v-if="p === 0">
                <v-img max-width="100px" :src="itm"></v-img>
              </td>
            </tr>
          </template>
          <template v-slot:[`item.SKU`]="{ item }">
            <tr>
              <td>
                <span class="font-weight-medium">{{ item.SKU }}</span><br />
                <span v-if="item.Barcode" class="grey--text">
                  BAR: {{ item.Barcode }}
                </span>
              </td>
            </tr>
          </template>
          <template v-slot:[`item.Brand`]="{ item }">
            <tr>
              <td>
                <span>{{ item.Brand }}</span><br />
                <span class="grey--text"> Currency: {{ item.Currency }} </span>
              </td>
            </tr>
          </template>
          <template v-slot:[`item.stock`]="{ item }">
            <v-chip small :color="item.stock < 1 ? 'grey' : 'green'" dark>
              {{ item.stock }}
            </v-chip>
          </template>
          <template v-slot:[`item.platforms`]="{ item }">
            <v-menu>
              <template v-slot:activator="{ on: menu, attrs }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on: tooltip }">
                    <span class="blue--text font-weight-medium" v-bind="attrs"
                      v-on="{ ...tooltip, ...menu }">Rules</span>
                  </template>
                  <tr v-for="(itm, p) in formatPlatformRules(item)" :key="p">
                    <td v-if="itm.allowed">
                      {{ itm.name
                      }}<span>
                        -
                        <v-icon color="green"> mdi-check-circle </v-icon></span>
                    </td>
                    <td v-else>
                      {{ itm.name
                      }}<span>
                        - <v-icon color="red"> mdi-close-circle </v-icon></span>
                    </td>
                  </tr>
                </v-tooltip>
              </template>
            </v-menu>
          </template>
          <template v-slot:[`item.Brand`]="{ item }">
            <tr>
              <td>
                <span>{{ item.Brand }}</span><br />
                <span class="grey--text"> Currency: {{ item.Currency }} </span>
              </td>
            </tr>
          </template>
          <template v-slot:[`item.stock`]="{ item }">
            <v-chip small :color="item.stock < 1 ? 'grey' : 'green'" dark>
              {{ item.stock }}
            </v-chip>
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on" size="40" @click="openHistory(item)"
                  color="accent">mdi-eye-circle</v-icon>
              </template>
              <span>View product history</span>
            </v-tooltip>
          </template>
          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length">
              <ProductInfo :product="item"></ProductInfo>
            </td>
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <v-dialog v-model="downloadPopup" width="500px">
      <v-card>
        <v-card-title class="footer basic--text"> Download file </v-card-title>
        <v-card-text>
          <v-row justify="center" class="mt-10">
            <v-col cols="6">
              <v-text-field placeholder="File name" label="File name" v-model="fileName" outlined dense color="accent">
              </v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn outlined color="success" @click="formatData">Get file</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <ProductHistoryDialog :product="productForHistory" ref="productHistoryDialog"></ProductHistoryDialog>
  </v-container>
</template>

<script>
import FilterForm from "@/components/organisms/FilterForm.vue";
import ProductInfo from "../organisms/ProductInfo.vue";
import ProductHistoryDialog from "../Descriptions/ProductHistoryDialog.vue";

export default {
  name: "NotExported",
  props: {},
  components: {
    FilterForm,
    ProductInfo,
    ProductHistoryDialog,
  },
  data: () => ({
    snackbarEmpty: false,
    errorEmpty: `Please select products to export.`,
    selectedProducts: [],
    loadingExport: false,
    loadingExportPiguLt: false,
    exportDone: false,
    loadingFlashSales: false,
    flashSalesDone: false,
    headers: [
      { text: "PLATFORMS", value: "platforms", class: "footer" },
      { text: "PHOTO", value: "Photos", class: "footer" },
      { text: "SKU", value: "SKU", class: "footer" },
      { text: "BARCODE", value: "Barcode", class: "footer" },
      { text: "CATEGORY", value: "Category", class: "footer" },
      { text: "CONDITION", value: "Condition", class: "footer" },
      { text: "BRAND", value: "Brand", class: "footer" },
      { text: "RRP", value: "RRP", class: "footer" },
      { text: "STOCK", value: "stock", class: "footer" },
      { text: "HISTORY", value: "actions", class: "footer" },
    ],
    items: [],
    expanded: [],
    search: "",
    loadingFilter: false,
    fileName: "",
    downloadPopup: false,
    platform: "",
    platforms: [
      {
        platform: "ebay.fr",
        language: "French",
        code: "fr",
      },
      {
        platform: "ebay.it",
        language: "Italian",
        code: "it",
      },
      {
        platform: "ebay.de",
        language: "German",
        code: "de",
      },
      {
        platform: "ebay.es",
        language: "Spanish",
        code: "es",
      },
      {
        platform: "ebay.co.uk",
        language: "English",
        code: "en",
      },
      {
        platform: "ebay.com",
        language: "English",
        code: "en",
      },
      {
        platform: "ebay.au",
        language: "English",
        code: "en",
      },
      {
        platform: "bcf.lt",
        language: "Lithuanian",
        code: "lt",
      },
      {
        platform: "bcfashion.com",
        language: "English",
        code: "en",
      },
    ],
    platformSelected: false,
    productForHistory: {},
    // NEW PROPERTIES FOR PAGINATION
    options: {},
    totalItems: 0,
    currentFilters: [],
    loading: false,
  }),
  watch: {
    items(val) {
      if (val.length == 0) {
        this.loadingFilter;
      }
    },
    // NEW WATCHER FOR PAGINATION
    options: {
      handler() {
        if (this.currentFilters.length > 0) {
          this.filterProducts(this.currentFilters);
        }
      },
      deep: true,
    },
  },
  async mounted() { },
  methods: {

    uploadToPlatform() {
      let platform = this.platform;
      let platformName = this.platform.platform;
      let SKUArray = this.getSKUArray(this.selectedProducts);
      this.$router.push({
        name: `platformExport`,
        params: { platform, platformName, SKUArray },
      });
    },
    getSKUArray(array) {
      let result = [];
      for (const product of array) {
        result.push(product.SKU);
      }
      return result;
    },
    showProductsToFix() {
      this.platformSelected = true;
    },
    openHistory(item) {
      this.productForHistory = item;
      this.$refs.productHistoryDialog.showDialog(item);
    },
    formatFilterValues(filters) {
      this.items = [];
      let finalData = [];
      let val = "";
      this.$refs.filterComponent.setLoading(true);

      finalData.push(["ExportState", "equals", "Not Exported"]);
      finalData.push(["Described", "equals", true]);

      if (filters.length > 0) {
        for (let obj of filters) {
          if (obj.condition == "Yes") {
            val = true;
          } else if (obj.condition == "No") {
            val = false;
          } else if (obj.property["type"] === "Number") {
            val = parseInt(obj.value);
          } else if (obj.property["type"] === "Array") {
            val = obj.value;
          } else {
            val = obj.value;
          }
          finalData.push([obj.property["name"], obj.condition, val]);
        }
      }

      // NEW: Store filters for pagination
      this.currentFilters = finalData;
      this.filterProducts(finalData);
    },
    showPopup() {
      this.downloadPopup = true;
    },
    formatData() {
      this.downloadPopup = false;
      this.formatExport();
    },
    formatExport() {
      let SKUArray = [];

      if (this.selectedProducts.length == 0) {
        this.snackbarEmpty = true;
      } else {
        this.loadingExport = true;
        this.exportDone = false;
        for (let item of this.selectedProducts) {
          SKUArray.push(item.SKU);
        }

        this.exportProducts(SKUArray);
      }
    },
    formatPlatformRules(item) {
      let tempArray = [];
      let general = false;
      let ebaycom = false;
      let ebayother = false;
      let ebayau = false;
      let shopify = false;

      if (
        item.Quantity > 0 &&
        item.RRP > 0 &&
        item.Photos.length > 0 &&
        "Size" in item
      ) {
        general = true;
      }
      //eBay.com
      if (!item.Defect && item.Features && item.Accents) {
        ebaycom = true;
      }
      //ebay other
      if (item.Features && item.Accents) {
        ebayother = true;
      }
      //ebayau
      if (item.Category.includes("Lingerie")) {
        if (item.Defect) {
          ebayau = false;
        } else {
          ebayau = true;
        }
      } else {
        ebayau = true;
      }
      //bcf, bcfashion
      if (
        !item.Defect &&
        ["With tag(s)", "With box", "With original packaging"].indexOf(
          item.Condition
        ) > -1
      ) {
        shopify = true;
      }

      if (general && shopify) {
        tempArray.push({ name: "bcf.lt", allowed: true });
        tempArray.push({ name: "bcfashion.com", allowed: true });
      } else {
        tempArray.push({ name: "bcf.lt", allowed: false });
        tempArray.push({ name: "bcfashion.com", allowed: false });
      }
      if (general && ebaycom) {
        tempArray.push({ name: "eBay.com", allowed: true });
      } else {
        tempArray.push({ name: "eBay.com", allowed: false });
      }
      if (general && ebayau) {
        tempArray.push({ name: "eBay.au", allowed: true });
      } else {
        tempArray.push({ name: "eBay.au", allowed: false });
      }
      if (general && ebayother) {
        tempArray.push({ name: "eBay.co.uk", allowed: true });
        tempArray.push({ name: "eBay.it", allowed: true });
        tempArray.push({ name: "eBay.fr", allowed: true });
        tempArray.push({ name: "eBay.de", allowed: true });
        tempArray.push({ name: "eBay.at", allowed: true });
      } else {
        tempArray.push({ name: "eBay.co.uk", allowed: false });
        tempArray.push({ name: "eBay.it", allowed: false });
        tempArray.push({ name: "eBay.fr", allowed: false });
        tempArray.push({ name: "eBay.de", allowed: false });
        tempArray.push({ name: "eBay.at", allowed: false });
      }
      let sku = item.SKU;
      let tempObj = {};
      tempObj[sku] = tempArray;

      return tempArray;
    },
    exportProducts(array) {
      this.$store
        .dispatch("exportProducts", array)
        .then((response) => {
          this.textColor = "";

          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `${this.fileName}.csv`);
          document.body.appendChild(link);
          link.click();

          this.loadingExport = false;
          this.exportDone = true;

          this.items = [];
          this.selectedProducts = [];
          this.fileName = "";
          this.$refs.filterComponent.formatValues();
        })
        .catch((error) => {
          this.statusDialog = true;
          this.textColor = "red--text";
          this.pending = false;
          if (error.response) {
            // client received an error response (5xx, 4xx)
            this.responseMessage = error.response.data;
            switch (error.response.status) {
              case 400:
                this.filename = "empty.png";
                break;
              case 401:
                //clear local storage, push to login
                localStorage.clear();
                this.$router.push("login");
                break;
              case 403:
                this.filename = "403_forbidden.png";
                break;
              case 404:
                this.responseMessage = "Bad request. Please contact TECH team.";
                this.filename = "void.png";
                break;
              case 500:
                this.filename = "server_down.png";
            }
          } else {
            // anything else
            this.responseMessage = "Sorry... Someting went wrong.";
            this.filename = "feeling_blue.png";
          }
        });
    },
    filterProducts(data) {
      // NEW: Get pagination params from options
      const { page, itemsPerPage } = this.options;

      // NEW: Set loading state
      this.loading = true;

      this.$store
        .dispatch("filterProducts", {
          filters: data,
          page: page || 1,
          limit: itemsPerPage || 100
        })
        .then((response) => {
          // NEW: Handle new response format with pagination
          if (response.data.data) {
            this.items = response.data.data;
            this.totalItems = response.data.pagination?.total || response.data.data.length;
          } else {
            // Fallback for old format
            this.items = response.data;
            this.totalItems = response.data.length;
          }

          this.selectedProducts = [];
          this.loading = false;
          this.$refs.filterComponent.setLoading(false);
        })
        .catch((error) => {
          this.loading = false;
          this.$refs.filterComponent.setLoading(false);
          let errorMsg = "";
          errorMsg = error.response.data
            ? error.response.data
            : "Something went wrong while filtering.";

          this.$refs.filterComponent.setLoadingFailed(true, errorMsg);
          console.log(error);
        });
    },
    async getPlatforms() {
      try {
        const response = await this.$store.dispatch("getPlatforms");
        this.platforms = response.data;
        console.log("platforms", response);
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
